import React from 'react';
const problems = [{
  short: 'Sin plan',
  desc: 'Llegás a la pileta sin saber qué ejercicio dar'
}, {
  short: 'Sin progresión',
  desc: 'Tus alumnos no avanzan de nivel'
}, {
  short: '40% abandona',
  desc: 'Se van antes del tercer mes'
}, {
  short: 'Grupos mixtos',
  desc: 'Niveles distintos en la misma clase'
}, {
  short: 'Padres sin respuesta',
  desc: '"¿Qué aprendió mi hijo?" y no tenés datos'
}, {
  short: 'No podés cobrar más',
  desc: 'Sin progreso escrito no hay justificación'
}];
export function ProblemSection() {
  return <section className="w-full bg-[#0A0A0F] py-8 px-4 pt-[0px] pb-[0px]" data-id="element-163">
      <div className="max-w-3xl mx-auto text-center" data-id="element-164">
        <h2 className="text-xl sm:text-2xl font-bold text-white mb-6" data-id="element-165">
          Si sos profesor de natación,
          <br data-id="element-166" />
          <span className="text-[#FF6B00]" data-id="element-167">esto te va a sonar familiar:</span>
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 text-left mb-8" data-id="element-168">
          {problems.map((p, i) => <div key={i} className="bg-[#16161F] border border-[#FF6B0033] rounded-xl p-3.5 flex items-start gap-3" data-id="element-169">
              <span className="text-[#FF6B00] text-lg flex-shrink-0 mt-0.5" data-id="element-170">
                ❌
              </span>
              <div data-id="element-171">
                <p className="text-white text-sm font-bold" data-id="element-172">{p.short}</p>
                <p className="text-[#B0B0C0] text-xs mt-0.5" data-id="element-173">{p.desc}</p>
              </div>
            </div>)}
        </div>

        <p className="text-[#FF6B00] text-2xl sm:text-3xl font-black mb-6" data-id="element-174">
          ¿Cuántas clases más vas a improvisar?
        </p>

        {/* Orange divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#FF6B00] to-transparent w-full" data-id="element-175" />
      </div>
    </section>;
}